import React, { Suspense } from "react";
import { CirromLoadingLogo } from "./utils/CirromLoadingLogo";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";

interface LazyWrapperProps {
  children: React.ReactNode;
}

export const LazyWrapper: React.FC<LazyWrapperProps> = ({ children }) => {
  return (
    <Suspense
      fallback={
        <Box
          style={{
            backgroundColor: "background.default",
            display: "flex",
            flexDirection: "column",
            height: "100%",
            justifyContent: "center",
          }}
        >
          <Container maxWidth="sm" style={{ padding: 0 }}>
            <div
              style={{
                justifyContent: "center",
                display: "flex",
                margin: "10px",
              }}
            >
              <CirromLoadingLogo iconHeight="100px" />
            </div>
          </Container>
        </Box>
      }
    >
      {children}
    </Suspense>
  );
};
